import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Address\CreateAddressController::__invoke
* @see app/Http/Controllers/Address/CreateAddressController.php
* @route '/api/address'
*/
const CreateAddressController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAddressController.url(options),
    method: 'post',
})

CreateAddressController.definition = {
    methods: ["post"],
    url: '/api/address',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Address\CreateAddressController::__invoke
* @see app/Http/Controllers/Address/CreateAddressController.php
* @route '/api/address'
*/
CreateAddressController.url = (options?: RouteQueryOptions) => {
    return CreateAddressController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Address\CreateAddressController::__invoke
* @see app/Http/Controllers/Address/CreateAddressController.php
* @route '/api/address'
*/
CreateAddressController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAddressController.url(options),
    method: 'post',
})

export default CreateAddressController